export const isTestEnvironment = () => process.env.NODE_ENV === 'test';

export const isJestExists = () => typeof jest !== 'undefined';

export const createEmptyFunctionMock = () =>
  isTestEnvironment() && isJestExists() ? jest.fn() : () => {};
